import React, { useEffect, useRef, useState } from 'react';
// import 'sceditor/minified/themes/default.min.css';  // 引入 SCEditor 主題樣式
import "../../assets/styles/custom-secditor/custom-default-secditor.scss"; //自訂主題樣式
import 'sceditor/minified/sceditor.min.js';         // 引入 SCEditor 的 JavaScript 文件
import 'sceditor/minified/formats/xhtml.js';    // 引入 SCEditor 的格式支持

const CustomSceditor = ({ sceditorRef, value, language="en", disabled=false }) => {
    const editorInstance = useRef(null);

    const languagePacks = {
        en: {
          Bold: "Bold 粗體",
          Italic: "Italic",
          Underline: "Underline",
          Strikethrough: "Strikethrough",
          Subscript: "Subscript",
          Superscript: "Superscript",
          Left: "Align Left",
          Center: "Align Center",
          Right: "Align Right",
          Justify: "Justify",
          Font: "Font",
          Size: "Size",
          Color: "Color",
          RemoveFormat: "Remove Format",
          Cut: "Cut",
          Copy: "Copy",
          Paste: "Paste",
          PasteText: "Paste as Text",
          BulletList: "Bullet List",
          OrderedList: "Ordered List",
          Indent: "Indent",
          Outdent: "Outdent",
          HorizontalRule: "Horizontal Rule",
          Image: "Image",
          Link: "Link",
          Unlink: "Unlink",
          Date: "Date",
          Time: "Time",
          Print: "Print",
          Maximize: "Maximize",
          Source: "Source",
          Clear: "Clear",
          Close: "Close"
        },
        // Add more languages here if needed
        zh: {
          Bold: "加粗",
          Italic: "斜体",
          Underline: "下划线",
          Strikethrough: "删除线",
          Subscript: "下标",
          Superscript: "上标",
          Left: "左对齐",
          Center: "居中",
          Right: "右对齐",
          Justify: "两端对齐",
          Font: "字体",
          Size: "大小",
          Color: "颜色",
          RemoveFormat: "清除格式",
          Cut: "剪切",
          Copy: "复制",
          Paste: "粘贴",
          PasteText: "粘贴文本",
          BulletList: "项目符号列表",
          OrderedList: "编号列表",
          Indent: "增加缩进",
          Outdent: "减少缩进",
          HorizontalRule: "水平线",
          Image: "插入图片",
          Link: "插入链接",
          Unlink: "取消链接",
          Date: "日期",
          Time: "时间",
          Print: "打印",
          Maximize: "最大化",
          Source: "源代码",
          Clear: "清除",
          Close: "关闭"
        }
      };
    



  useEffect(() => {
    const SCEditor = window.sceditor;
    
    if (sceditorRef.current && SCEditor) {
      

        // Define a function to apply the language pack
      const applyLanguagePack = (lang) => {
        const languagePack = languagePacks[lang] || languagePacks.en;

        // Extend the SCEditor commands with custom text
        SCEditor.commands.bold.title = languagePack.Bold;
        SCEditor.commands.italic.title = languagePack.Italic;
        SCEditor.commands.underline.title = languagePack.Underline;
        SCEditor.commands.subscript.title = languagePack.Subscript;
        SCEditor.commands.superscript.title = languagePack.Superscript;
        SCEditor.commands.left.title = languagePack.Left;
        SCEditor.commands.center.title = languagePack.Center;
        SCEditor.commands.right.title = languagePack.Right;
        SCEditor.commands.justify.title = languagePack.Justify;
        SCEditor.commands.font.title = languagePack.Font;
        SCEditor.commands.size.title = languagePack.Size;
        SCEditor.commands.color.title = languagePack.Color;
        SCEditor.commands.removeformat.title = languagePack.RemoveFormat;
        SCEditor.commands.cut.title = languagePack.Cut;
        SCEditor.commands.copy.title = languagePack.Copy;
        SCEditor.commands.paste.title = languagePack.Paste;
        SCEditor.commands.pastetext.title = languagePack.PasteText;
        SCEditor.commands.bulletlist.title = languagePack.BulletList;
        SCEditor.commands.orderedlist.title = languagePack.OrderedList;
        SCEditor.commands.indent.title = languagePack.Indent;
        SCEditor.commands.outdent.title = languagePack.Outdent;
        SCEditor.commands.horizontalrule.title = languagePack.HorizontalRule;
        SCEditor.commands.image.title = languagePack.Image;
        SCEditor.commands.link.title = languagePack.Link;
        SCEditor.commands.unlink.title = languagePack.Unlink;
        SCEditor.commands.date.title = languagePack.Date;
        SCEditor.commands.time.title = languagePack.Time;
        SCEditor.commands.print.title = languagePack.Print;
        SCEditor.commands.maximize.title = languagePack.Maximize;
        SCEditor.commands.source.title = languagePack.Source;
      };

      // Apply the language pack and initialize SCEditor      
    //   applyLanguagePack(language);
      editorInstance.current = SCEditor.create(sceditorRef.current, {
          plugins: 'xhtml customTablePlugin',
          // 尚有 table print image 但太難用了
          toolbar: `bold,italic,underline,strike,subscript,superscript,left,center,right,justify,font,size,color,removeformat,cut,copy,pastetext,
          bulletlist,orderedlist,indent,outdent,horizontalrule,image,link,unlink,date,time,maximize,clear,insertTableButton`,
          startValue: value,
          locale: language, // Specify the language
          readOnly: disabled, // 設定編輯器為唯讀模式
        });



        // Apply custom language pack 沒用
    //   SCEditor.setLocale(language, languagePacks[language] || languagePacks.en);
        
        

      const containers = document.querySelectorAll('.sceditor-container:not(.sceditor-maximize)');
      if (containers?.length > 0) {
        containers[0].style.removeProperty('width');
        // container.style.removeProperty('height');
      }
      

    }

    return () => {
      if (sceditorRef.current) {
        const editorInstance = SCEditor.instance(sceditorRef.current);
        if (editorInstance) {
          editorInstance.destroy();
        }
      }
    };
  }, [value]);

  // 處理 disabled 狀態變化
  useEffect(() => {
    if (editorInstance.current && sceditorRef.current) {
      const instance = window.sceditor.instance(sceditorRef.current);
      if (instance) {
        instance.readOnly(disabled);
      }
    }
  }, [disabled]);

  return (
    <textarea ref={sceditorRef} defaultValue={value}  style={{ width: `calc(100% - 50px)`, height: `calc(100vh - 50px)` }} />
  );
};

export default CustomSceditor;